import { motion } from "framer-motion";

const TONES = {
  cyan: { text: "text-[#00E5FF]", ring: "ring-[#00E5FF]/25" },
  green: { text: "text-[#39FF14]", ring: "ring-[#39FF14]/25" },
  red: { text: "text-[#FF3B30]", ring: "ring-[#FF3B30]/25" },
  white: { text: "text-white", ring: "ring-white/10" },
};

export default function KpiCard({ label, value, suffix, tone = "white", delay = 0, sub, testId }) {
  const t = TONES[tone] || TONES.white;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5 }}
      className="card-surface rounded-xl p-5 lg:p-6"
      data-testid={testId}
    >
      <div className="text-[10px] font-mono tracking-widest uppercase text-white/45">{label}</div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className={`font-display text-4xl lg:text-5xl font-semibold ${t.text}`}>{value}</span>
        {suffix && <span className="font-mono text-xs text-white/40">{suffix}</span>}
      </div>
      {sub && <div className="mt-2 font-mono text-[11px] text-white/45">{sub}</div>}
    </motion.div>
  );
}
